<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showDisciplinaryDetailSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'850px'}">
    <ng-template pTemplate="header">
        <div class="flex flex-row justify-content-between" style="margin: 20px 30px 0px 5px; width: 100%;">

            <div class="flex flex-row">
                <div>
                    <img class="disciplinary-header-complaint-img" src="{{disciplinary.ComplaintImageUrl}}" />
                </div>
                <div class="disciplinary-header-complaint-info-block">
                    <div class="disciplinary-header-complaint-fullname">{{disciplinary.ComplaintFullName}}</div>
                    <div class="disciplinary-header-complaint-member-since">Member since: <span class="disciplinary-header-complaint-created">{{disciplinary.ComplaintMemberSince}}</span></div>
                </div>
            </div>

            <div>
                <div class="disciplinary-header-did-text">Disciplinary ID:</div>
                <div class="disciplinary-header-did-value">{{disciplinary.DisciplinaryId}}</div>
            </div>

        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <div *ngIf="activeMenuTab === menuTab.Details">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 27px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="disciplinary-border-block">
                    <div class="flex flex-row flex-space-between">
                        <div>
                            <span class="disciplinary-status-label">Disciplinary Status:</span>
                            <span class="disciplinary-status-value"
                                  [style.color]="disciplinary.StatusColor"
                                  [style.background-color]="disciplinary.StatusBackColor">{{disciplinary.DisciplinaryStatusText}}</span>
                        </div>
                        <div>
                            <span class="disciplinary-priority-value">{{disciplinary.PriorityTypeText}} Priority</span>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div>
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Disciplinary ID:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.DisciplinaryId}}</div>

                            <div class="disciplinary-item disciplinary-label">Reported Date & Time:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CreatedAt}}</div>

                            <div class="disciplinary-item disciplinary-label">Source:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.SourceCase}}</div>

                            <div class="disciplinary-item disciplinary-label">Channel:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.Channel}}</div>

                            <div class="disciplinary-item disciplinary-label">Prohibited Acts:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.ProhibitedAct}}</div>

                            <div class="disciplinary-item disciplinary-label">Offense Code:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.Code}}</div>

                            <div class="disciplinary-item disciplinary-label">Customer Affected?</div>
                            <div class="disciplinary-item disciplinary-value">{{(disciplinary.IsCustomerAffected) ? 'Yes' : 'No'}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div>
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Customer name:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerName}}</div>

                            <div class="disciplinary-item disciplinary-label">Customer E-mail:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerEmail}}</div>

                            <div class="disciplinary-item disciplinary-label">Customer Phone:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.CustomerPhone}}</div>

                            <div class="disciplinary-item disciplinary-label">Date, Time of offense:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.OffenseDateTime}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="disciplinary-border-block">
                    <div class="disciplinary-note-label">Notes</div>
                    <div class="disciplinary-note-description">{{disciplinary.Note}}</div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="flex flex-row flex-space-between m-4">
                    <div>
                        <span class="disciplinary-representative-fullname-label">Xpress Representative:</span>
                        <span class="disciplinary-representative-fullname">{{disciplinary.RepresentativeFullName}}</span>
                    </div>
                </div>

            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px p-4">
                <button class="bluedark-btn" pButton label="Print Report"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Investigation">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 277px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="mt-20">
                    <div class="flex flex-row flex-wrap">
                        <div class="disciplinary-column">
                            <div class="disciplinary-item disciplinary-label">Investigator:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationUserFullName}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Start:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationStartedAt}}</div>

                            <div class="disciplinary-item disciplinary-label">Investigation Finish:</div>
                            <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationFinishedAt}}</div>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="disciplinary-note-label">Investigation report:</div>
                    <br />
                    <textarea rows="5" cols="30" [(ngModel)]="disciplinary.InvestigationReport" placeholder="Include your findings" pInputTextarea [autoResize]="true"></textarea>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="cp-upload-img-block__upload">
                        <div class="disciplinary-note-label">Investigation Attachments:</div>
                        <br />
                        <div *ngIf="this.disciplinary.InvestigationFileReports">
                            <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.InvestigationFileReports">
                                <a href="{{file.FileUrl}}" target="_blank">{{file.FileName}}</a>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="flex flex-row flex-space-between m-4">
                    <div>
                        <span class="disciplinary-note-label">Investigation Recommendation:</span>
                        <span class="disciplinary-status-value"
                              [style.color]="disciplinary.DisciplinaryActionColor"
                              [style.background-color]="disciplinary.DisciplinaryActionBackColor">{{disciplinary.DisciplinaryActionText}}</span>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px p-4">
                <button class="bluedark-btn" pButton label="Print Report"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Hearing">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 277px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row flex-wrap mt-20">
                    <div class="disciplinary-column">
                        <div class="disciplinary-item disciplinary-label">Investigator:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.InvestigationUserFullName}}</div>

                        <div class="disciplinary-item disciplinary-label">Hearing Date:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.HearingDate}}</div>

                        <div class="disciplinary-item disciplinary-label">Hearing Location:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.HearingLocationText}}</div>
                    </div>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="disciplinary-note-label">Hearing Report:</div>
                    <br />
                    <textarea rows="5" cols="30" [(ngModel)]="disciplinary.HearingReport" placeholder="Please record hearing results, including summary of investigation and discussiion points for the driver" pInputTextarea [autoResize]="true"></textarea>
                </div>

                <div class="disciplinary-hr"></div>

                <div class="m-4">
                    <div class="cp-upload-img-block__upload">
                        <div class="disciplinary-note-label">Hearing Attachments:</div>
                        <br />
                        <div *ngIf="this.disciplinary.InvestigationFileReports">
                            <p class="disciplinary-report-filename" *ngFor="let file of this.disciplinary.HearingFileReports">
                                <a href="{{file.FileUrl}}" target="_blank">{{file.FileName}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px p-4">
                <button class="bluedark-btn" pButton label="Print Report"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Disciplinary">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 277px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row flex-wrap mt-20">
                    <div class="disciplinary-column">
                        <div class="disciplinary-item disciplinary-label">Disciplinary action:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.DisciplinaryActionText}}</div>

                        <div class="disciplinary-item disciplinary-label">Period:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.DisciplinaryPeriodText}}</div>

                        <div class="disciplinary-item disciplinary-label">Start of Period:</div>
                        <div class="disciplinary-item disciplinary-value">{{disciplinary.SanctionStartedAt}}</div>

                        <div class="disciplinary-item disciplinary-label" *ngIf="disciplinary.SanctionFineshedAt">End of Period:</div>
                        <div class="disciplinary-item disciplinary-value" *ngIf="disciplinary.SanctionFineshedAt">{{disciplinary.SanctionFineshedAt}}</div>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px p-4">
                <button class="bluedark-btn" pButton label="Print Report"></button>
            </div>
        </div>


    </div>

</p-sidebar>